import React from 'react'
import { ProfileData } from '../../../../helpers/models/Models';
import SecHeading from '../../../../constants/SecHeading';
import { CiLocationOn } from "react-icons/ci";
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';

interface ProfileDataDetailsProps {
    ProfileDataDetails: ProfileData | null;
}
const ParentsView: React.FC<ProfileDataDetailsProps> = ({ ProfileDataDetails }) => {
    return (
        <div>
            <SecHeading icon={<CiLocationOn />} type='add' label='Address' />
            <p className="border-t border-slate-300 pt-2 border-dashed"></p>
            <Grid container columnSpacing={3} rowSpacing={1}>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Father Name:' name='spouses_name' type='text' value={ProfileDataDetails?.father_name || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Father Name(Nepali):' name='spouses_name' type='text' value={ProfileDataDetails?.father_name_nep || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Grand Father Name:' name='spouses_name' type='text' value={ProfileDataDetails?.grand_father_name || ""} disabled />
                </Grid>
                <Grid item xl={3} lg={3} sm={6} xs={12} md={3}>
                    <InputTextBox label='Grand Father Name(Nepali):' name='spouses_name' type='text' value={ProfileDataDetails?.grand_father_name_nep || ""} disabled />
                </Grid>
                
            </Grid>
        </div>
    )
}

export default ParentsView